import { CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { DatePicker, Form, FormInstance, FormProps, Input, Modal, Select } from "antd";
import { useForm } from 'antd/lib/form/Form';
import dayjs from "dayjs";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import { getListAttributeVehicle } from "../../../../../api/attributeVehicle/attributeVehicleApi";
import { addCar } from "../../../../../api/car/carApi";
import { ICarCompany, gGroupColorCar, getCLCarLines, getCLCategoryCar, getCLCountry, getCLModelVehicle, getCLTypeVehicle, getCLVehicle, getCLVehicleGroup, getListCarColor } from "../../../../../api/selectOption/selectOptionsApi";
import { IRelative, ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi";
import { URL_COUNTRY } from "../../../../../env";
import useToast from "../../../../../hook/useToast";
import { CARTYPE } from "../../../../../services/data";
import { fommatSelectOption, fommatSelectOptionTitle } from "../../../../../until";
import './style.scss';
import moment from "moment";
interface ModalProps {
  isOpen: boolean
  sLCategoryCar: ICarCompany[]
  // sLAttributeVehicle: IAttributeVehicle[]

  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}
const ModalCreateCar: React.FC<ModalProps> = ({
  isOpen, sLCategoryCar,
  onSubmitFormModal, closeModal
}) => {
  const [form] = useForm();
  const pushToast = useToast();
  const { CAR_BUS, CAR } = CARTYPE

  const inputRef = useRef<FormInstance>(null);
  const imgRef = useRef<HTMLInputElement>(null);

  const isProgrammaticCarLineSet = useRef(false);
  const isProgrammaticTypeVehicleSet = useRef(false);
  const isProgrammaticGroupVehicleSet = useRef(false);
  const isProgrammaticProductVehicleSet = useRef(false);
  const isProgrammaticCategorySet = useRef(false);
  const isProgrammaticColor = useRef(false);
  // gCLModelVehicle
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [advanced, setAdvanced] = useState(false)

  const idCarLines = Form.useWatch("idCarLines", form);
  const idTypeVehicle = Form.useWatch("idTypeVehicle", form);
  const idGroupVehicle = Form.useWatch("idGroupVehicle", form);
  const idProductVehicle = Form.useWatch("idProductVehicle", form);
  const idCategoryCar = Form.useWatch("idCategoryCar", form);
  const idColor = Form.useWatch("idColor", form);



  //av

  const [sLColorCar, setSLColorCar] = useState<IRelative[]>([])
  const [cLGroupColorCar, setCLGroupColorCar] = useState<ISelectOption[]>([])
  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])
  const [cLTypeVehicle, setCLTypeVehicle] = useState<ISelectOption[]>([])
  const [cLCategoryCar, setCLCategoryCar] = useState<ISelectOption[]>([])
  const [cLVehicleGroup, setCLVehicleGroup] = useState<ISelectOption[]>([])
  const [cLModelVehicle, setCLModelVehicle] = useState<ISelectOption[]>([])
  const [cLCarColor, setCLCarColor] = useState<ISelectOption[]>([])
  const [cLSegmentsVehicle, setCLSegmentsVehicle] = useState<ISelectOption[]>([])
  const [cLFuel, setCLFuel] = useState<ISelectOption[]>([])
  const [cLOrigin, setCLOrigin] = useState<ICarCompany[]>([])
  const [cLDesigns, setCLDesigns] = useState<ISelectOption[]>([])
  const [cLBarrelsystem, setCLBarrelsystem] = useState<ISelectOption[]>([])


  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  const gCLTypeVehicle = async () => {
    if (!idCarLines) return
    if (idCarLines === CAR_BUS) return
    const result = await getCLTypeVehicle(idCarLines)
    if (result?.status) {
      setCLTypeVehicle(fommatSelectOption(result.data))
    }
  }

  const gCLVehicleGroup = async () => {
    if (!idCategoryCar) return
    const result = await getCLVehicleGroup(
      idCarLines, idCategoryCar
    )
    if (result?.status) {
      setCLVehicleGroup(fommatSelectOption(result.data))
    }
  }

  // const gCLVehicle = async () => {
  //   if (!idGroupVehicle) return
  //   const result = await getCLVehicle(
  //     idCarLines, idTypeVehicle, idGroupVehicle
  //   )
  //   if (result?.status) {
  //     setCLVehicle(fommatSelectOption(result.data))
  //   }
  // }

  const gCLCategoryCar = async () => {
    if (idCarLines === CAR_BUS) {
      const result = await getCLCategoryCar(
        idCarLines, undefined
      )
      if (result?.status) {
        setCLCategoryCar(fommatSelectOption(result.data))
      }
    } else {
      if (!idTypeVehicle) return
      const result = await getCLCategoryCar(
        idCarLines, idTypeVehicle
      )
      if (result?.status) {
        setCLCategoryCar(fommatSelectOption(result.data))
      }
    }
  }
  const gCLModelVehicle = async () => {

    if (idCarLines === CAR_BUS) {
      if (!idGroupVehicle) return
      const result = await getCLModelVehicle(undefined, idCategoryCar,
        idCarLines, idGroupVehicle,
      )
      if (result?.status) {
        setCLModelVehicle(fommatSelectOption(result.data))
      }
    } else {
      if (!idCategoryCar) return
      const result = await getCLModelVehicle(idTypeVehicle, idCategoryCar,
        idCarLines, undefined,
      )
      if (result?.status) {
        setCLModelVehicle(fommatSelectOption(result.data))
      }
    }
  }
  // màu xe
  const gCLCarColor = async () => {
    if (!idCategoryCar) return
    const result = await getListCarColor(idCategoryCar,
    )
    if (result?.status) {
      setCLCarColor(fommatSelectOption(result.data))
    }
  }
  // nhóm màu
  const gCLGroupColorCar = async () => {
    if (!idColor) return
    const result = await gGroupColorCar(idColor)
    if (result?.status) {
      setCLGroupColorCar(fommatSelectOption([result.data]))
    }
  }

  const gCLSegmentsVehicle = async () => {
    const result = await getListAttributeVehicle(1);
    if (result?.status) {
      setCLSegmentsVehicle(fommatSelectOptionTitle(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gCLAdvanced = async (id: number) => {
    const result = await getListAttributeVehicle(id);
    if (result?.status) {
      switch (id) {
        case 5:
          //nl
          if (!cLFuel.length)
            setCLFuel(fommatSelectOption(result.data))
          break;
        case 3:
          //kd
          if (!cLDesigns.length)
            setCLDesigns(fommatSelectOption(result.data))
          break;
        // case 2:
        //   //mx
        //   setSLColorCar(result.data)
        //   break;
        case 4:
          //ht
          if (!cLBarrelsystem.length)
            setCLBarrelsystem(fommatSelectOption(result.data))
          break;
        default:
          break;
      }
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gCLCountry = async () => {
    const result = await getCLCountry()
    if (result?.status) {
      setCLOrigin(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const disabledDate = (current: dayjs.Dayjs) => {
    // Vô hiệu hóa các ngày sau năm hiện tại
    const currentYear = moment().year();
    return current.year() < 1900 || current.year() > currentYear + 1;
  };


  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null;
    setUploadedFile(file);
  };

  const handleUploadClick = (event: React.MouseEvent) => {

    event.preventDefault();
    const inputElement = document.querySelector('input[type="file"]') as HTMLInputElement | null;
    if (inputElement) {
      inputElement.click();
    }
  };
  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };


  const onFinish: FormProps["onFinish"] = async (values) => {
    const {
      title, code, idCarLines, idTypeVehicle, idGroupVehicle,
      idProductVehicle, idCategoryCar, idModelVehicle,
      idSegmentsVehicle, yearCreate, image, seatingCapacity, idFuel
      , idColor, idGroupColor, idBodyVehicle, idTypeBodyVehicle, idCountry,
      codeB7
    } = values;

    const year = new Date(yearCreate).getFullYear()

    const result = await addCar(
      title, code, idCarLines, idTypeVehicle,
      idCategoryCar, idModelVehicle, idSegmentsVehicle,
      image, yearCreate ? year : yearCreate,
      idGroupVehicle, idProductVehicle, seatingCapacity, idFuel,
      idColor, idGroupColor, idBodyVehicle, idTypeBodyVehicle,
      idCountry, codeB7
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result?.message)
    } else {
      onSubmitFormModal?.(false, result?.message)
    }
  };

  useEffect(() => {

    if (idCarLines === CAR_BUS) {
      gCLCategoryCar()
    } else {
      gCLTypeVehicle()
    }

    if (isProgrammaticCarLineSet.current) {
      isProgrammaticCarLineSet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idTypeVehicle", undefined);
      form.setFieldValue("idCategoryCar", undefined);
    }
  }, [idCarLines]);

  useEffect(() => {
    if (idTypeVehicle) {
      if (idCarLines !== CAR_BUS)
        gCLCategoryCar()

    }

    if (isProgrammaticTypeVehicleSet.current) {
      isProgrammaticTypeVehicleSet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idGroupVehicle", undefined);
      form.setFieldValue("idProductVehicle", undefined);
      form.setFieldValue("idCategoryCar", undefined);
    }
  }, [idTypeVehicle]);

  // useEffect(() => {
  //   if (idGroupVehicle) {
  //     if (idCarLines === CAR_BUS)
  //       gCLVehicle()
  //   }

  //   if (isProgrammaticGroupVehicleSet.current) {
  //     isProgrammaticGroupVehicleSet.current = false;
  //     return;
  //   }
  //   if (isOpen) {
  //     form.setFieldValue("idProductVehicle", undefined);
  //     form.setFieldValue("idCategoryCar", undefined);
  //   }

  // }, [idGroupVehicle]);

  // useEffect(() => {
  //   if (idProductVehicle) {
  //     gCLCategoryCar()
  //   }
  //   if (isProgrammaticProductVehicleSet.current) {
  //     isProgrammaticProductVehicleSet.current = false;
  //     return;
  //   }
  //   if (isOpen) {
  //     form.setFieldValue("idCategoryCar", undefined);
  //   }
  // }, [idProductVehicle]);

  useEffect(() => {
    if (idCategoryCar) {
      if (idCarLines === CAR)
        gCLModelVehicle()
      gCLCarColor()
      gCLVehicleGroup()
    }
    if (isProgrammaticCategorySet.current) {
      isProgrammaticCategorySet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idModelVehicle", undefined);
      form.setFieldValue("idColor", undefined);
      form.setFieldValue("idGroupVehicle", undefined);
    }

  }, [idCategoryCar]);


  useEffect(() => {
    if (idGroupVehicle) {
      gCLModelVehicle()
    }
    if (isProgrammaticCategorySet.current) {
      isProgrammaticCategorySet.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idModelVehicle", undefined);
      form.setFieldValue("idColor", undefined);
    }

  }, [idGroupVehicle]);


  useEffect(() => {
    if (idColor) {
      gCLGroupColorCar()
    }
    if (isProgrammaticColor.current) {
      isProgrammaticColor.current = false;
      return;
    }
    if (isOpen) {
      form.setFieldValue("idGroupColor", undefined);
    }
  }, [idColor]);

  useEffect(() => {
    if (isOpen) {
      gCLSegmentsVehicle()
      gCLAdvanced(3)
      gCLAdvanced(4)
      gCLAdvanced(5)
      if (!cLOrigin.length)
        gCLCountry()
      if (!cLCarLines.length)
        gCLCarLines()
    } else {
      isProgrammaticCarLineSet.current = false;
      isProgrammaticTypeVehicleSet.current = false;
      isProgrammaticGroupVehicleSet.current = false;
      isProgrammaticProductVehicleSet.current = false;
      isProgrammaticCategorySet.current = false
      isProgrammaticColor.current = false
      form.resetFields()

      setUploadedFile(null);

      // Reset input file element
      if (imgRef.current) {
        imgRef.current.value = "";
      }
    }

  }, [isOpen])
  return (
    <Form
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">Tạo mới thông tin xe</span>
          <CloseOutlined className="text-base text-8B8B8B" onClick={closeModal} />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content ant-modal-size"
        rootClassName="rs-modal-right"
        closeIcon={false}
        footer={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
          <span className="text-sm text-98A2B3 cursor-pointer" onClick={closeModal}>Huỷ</span>
          <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
            onClick={submitForm}
          >
            Lưu
          </button>
        </div>}
      >

        <div className="p-6 d-flex flex-column gap-3">
          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Mã xe</p> */}
            <Form.Item
              label={<span className="">Mã xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              layout="vertical"
              name="code"
              rules={[{ required: true, message: 'Nhập mã xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Input
                placeholder="Mã xe"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <Form.Item
              label={<span className="">Mã xe B7</span>}
              layout="vertical"
              name="codeB7"
              className="m-none-form-item text-explan text-label"
            >
              <Input
                placeholder="Mã xe B7"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>

          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Tên xe</p> */}
            <Form.Item
              label={<span className="">Tên xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              layout="vertical"
              name="title"
              rules={[{ required: true, message: 'Nhập tên xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Input
                placeholder="Tên xe"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2 font-regular input-custom h-8"
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Dòng xe</p> */}
            <Form.Item
              label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              layout="vertical"
              name="idCarLines"
              rules={[{ required: true, message: 'Chọn dòng xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Select
                placeholder="Dòng xe"
                allowClear
                // value={typeCar}
                options={cLCarLines}
                className="custome-select-t "

              />
            </Form.Item>
          </div>
          {idCarLines === CAR &&
            <div className="d-flex flex-column gap-1">
              {/* <p className="text-sm  font-regular text-344054">Loại xe</p> */}
              <Form.Item
                label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                layout="vertical"
                name="idTypeVehicle"
                rules={[{ required: true, message: 'Chọn loại xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Select
                  placeholder="Loại xe"
                  disabled={!idCarLines}
                  // value={categoryCar}
                  options={cLTypeVehicle}
                  className="custome-select-t "

                />
              </Form.Item>
            </div>
          }
          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Loại xe</p> */}
            <Form.Item
              label={<span className="">Thương hiệu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              layout="vertical"
              name="idCategoryCar"
              rules={[{ required: true, message: 'Chọn thương hiệu xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Select
                placeholder="Thương hiệu xe"

                disabled={idCarLines !== CAR_BUS ? !idTypeVehicle : !idCarLines}
                options={cLCategoryCar}
                className="custome-select-t "

              />
            </Form.Item>
          </div>
          {idCarLines === CAR_BUS && (
            <>
              <div className='d-flex flex-column gap-1' >
                {/* <p className="text-sm  font-regular text-344054">Loại xe</p> */}
                <Form.Item
                  label={<span className="">Nhóm sản phẩm xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                  layout="vertical"
                  name="idGroupVehicle"
                  rules={[{ required: true, message: 'Chọn nhóm sản phẩm xe!' }]}
                  className="m-none-form-item text-explan text-label"
                >
                  <Select
                    placeholder="Nhóm sản phẩm xe"
                    disabled={!idCategoryCar}
                    // value={categoryCar}
                    options={cLVehicleGroup}
                    className="custome-select-t "

                  />
                </Form.Item>
              </div>

              {/* <div className='d-flex flex-column gap-1'>
                <Form.Item
                  label={<span className="">Sản phẩm xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                  layout="vertical"
                  name="idProductVehicle"
                  rules={[{ required: true, message: 'Chọn sản phẩm xe!' }]}
                  className="m-none-form-item text-explan text-label"
                >
                  <Select
                    disabled={!idGroupVehicle}
                    placeholder="Sản phẩm xe"
                    options={cLVehicle}
                    className="custome-select-t "

                  />
                </Form.Item>
              </div> */}
            </>
          )
          }

          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Loại xe</p> */}
            <Form.Item
              label={<span className="">Mẫu xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              layout="vertical"
              name="idModelVehicle"
              rules={[{ required: true, message: 'Chọn mẫu xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Select
                placeholder="Mẫu xe"
                disabled={idCarLines !== CAR_BUS ? !idCategoryCar : !idGroupVehicle}
                options={cLModelVehicle}
                className="custome-select-t "

              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Loại xe</p> */}
            <Form.Item
              label={<span className="">Phân khúc xe</span>}
              layout="vertical"
              name="idSegmentsVehicle"
              // rules={[{ required: true, message: 'Chọn phân khúc xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Select
                placeholder="Phân khúc xe"
                options={cLSegmentsVehicle}
                className="custome-select-t "

              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            {/* <p className="text-sm  font-regular text-344054">Năm sản xuất</p> */}
            <Form.Item
              label={<span className="">Năm sản xuất</span>}
              layout="vertical"
              name="yearCreate"
              // rules={[{ required: true, message: 'Chọn năm sản xuất!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <DatePicker
                popupClassName="t-ctrl-date-picker"
                picker="year"
                placeholder={"Năm sản xuất"}

                className="w-full h-8 rounded-2 font-regular text-sm p-ant-picker size-input-picker border-F2F4F7 bg-FCFCFD"
                disabledDate={disabledDate}
              />
            </Form.Item>
          </div>
          {/* <div className="d-flex flex-column gap-2">
            <span className="font-regular" style={{ fontSize: 16.73, color: '#344054' }}>Tải ảnh lên <span className="pl-1" style={{ color: 'red' }}>*</span></span>
            <div className="border-F2F4F7 rounded-2-px w-104-px h-104-px bg-F9FAFB d-flex align-center justify-center relative">

              {uploadedFile ? (
                <div >

                  <Form.Item
                    name="img1"
                    rules={[

                    ]}
                    className="m-none-form-item text-explan text-label"
                  >
                    <input
                      type="file"
                      accept="image/*"
                      ref={imgRef}
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                  </Form.Item>
                  <img
                    src={URL.createObjectURL(uploadedFile)}
                    alt="Uploaded"
                    className="w-104-px h-104-px rounded-3 cursor-pointer"
                    onClick={() => (imgRef as any).current.click()}
                  />
                </div>
              ) : (
                <div >

                  <Form.Item

                    name="image"
                    rules={[
                      { required: true, message: 'vui lòng chọn ảnh!' },
                    ]}
                    className="m-none-form-item text-explan  absolute bottom_-22-px w-109-px left-0"
                  >
                    <input
                      type="file"
                      accept="image/*"
                      ref={imgRef}
                      onChange={handleFileChange}
                      style={{ display: 'none' }}
                    />
                  </Form.Item>
                  <div
                    className="d-flex flex-column align-center gap-2 cursor-pointer"
                    onClick={handleUploadClick}
                  >
                    <PlusOutlined className="text-sm text-252626" />
                    <span className="text-sm text-98A2B3 text-center">Tải lên <br /> Logo</span>
                  </div>
                </div>
              )}

            </div>
          </div> */}
          <div className="d-flex flex-column   overflow-hidden">
            <div className="border-F2F4F7 rounded-2-px w-104-px h-104-px bg-F9FAFB d-flex align-center justify-center relative"
            >
              {uploadedFile ? (
                <img
                  src={URL.createObjectURL(uploadedFile)}
                  alt="Uploaded"
                  className="w-104-px  rounded-3 cursor-pointer"
                  onClick={() => (imgRef as any).current.click()}
                />
              ) : (
                <div
                  className="d-flex flex-column align-center gap-2 cursor-pointer"
                  onClick={handleUploadClick}
                >
                  <PlusOutlined className="text-sm text-252626" />
                  <span className="text-sm text-98A2B3 text-center">
                    Tải lên <br /> Logo
                  </span>
                </div>
              )}


            </div>
            <Form.Item
              className='custom-err-modal'
              name="image"
              rules={[{ required: true, message: "Vui lòng tải lên logo!" }]}
              valuePropName="file"
              getValueFromEvent={(e) => {
                if (Array.isArray(e)) return e;
                return e?.target?.files?.[0];
              }}
            >
              <input
                type="file"
                accept="image/*"
                style={{ display: "none" }}
                ref={imgRef}
                onChange={handleFileChange}
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Số chỗ</p>
            <Form.Item
              name="seatingCapacity"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) return Promise.resolve(); // cho phép để trống
                    const num = Number(value);

                    if (!Number.isInteger(num)) {
                      return Promise.reject(new Error('Nhập số nguyên!'));
                    }
                    if (num <= 0) {
                      return Promise.reject(new Error('Số phải lớn hơn 0!'));
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              className="m-none-form-item text-explan"
            >
              <Input
                placeholder="Số chỗ"
                type="number"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              // value={aNumberseat}
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Nhiên liệu</p>
            <Form.Item
              name="idFuel"
              rules={[{ required: advanced, message: 'Nhập nhiên liệu!' }]}
              className="m-none-form-item text-explan"
            >
              <Select
                placeholder="Nhiên liệu"
                // onChange={handleChangeFuel}
                options={cLFuel}
                className="custome-select-98A2B3 "

              // value={aFuel}
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Màu Xe</p>
            <Form.Item
              name="idColor"
              rules={[{ required: advanced, message: 'Chọn màu xe!' }]}
              className="m-none-form-item text-explan"
            >
              <Select
                placeholder="Màu Xe"
                disabled={!idCategoryCar}
                options={cLCarColor}
                className="custome-select-98A2B3 "

              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Nhóm màu Xe</p>
            <Form.Item
              name="idGroupColor"
              rules={[{ required: advanced, message: 'Chọn nhóm màu xe!' }]}
              className="m-none-form-item text-explan"
            >
              <Select
                placeholder="Nhóm màu Xe"
                disabled={!idColor}
                options={cLGroupColorCar}
                className="custome-select-98A2B3 "

              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Kiểu dáng</p>

            <Form.Item
              name="idBodyVehicle"
              rules={[{ required: advanced, message: 'Chọn kiểu dáng ' }]}
              className="m-none-form-item text-explan"
            >
              <Select
                placeholder="Kiểu dáng"
                options={cLDesigns}
                className="custome-select-98A2B3 "

              // value={aDesigns}
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Hệ thùng</p>
            <Form.Item
              name="idTypeBodyVehicle"
              rules={[{ required: advanced, message: 'Chọn hệ thùng!' }]}
              className="m-none-form-item text-explan"
            >
              <Select
                placeholder="Hệ thùng"
                options={cLBarrelsystem}
                className="custome-select-98A2B3 "

              // value={aBarrelsystem}
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Xuất xứ</p>
            <Form.Item
              name="idCountry"
              rules={[{ required: advanced, message: 'Chọn xuất xứ!' }]}
              className="m-none-form-item text-explan"
            >
              <Select
                placeholder="Xuất xứ"
                options={
                  cLOrigin.map(option => ({
                    value: option.id,
                    label: (
                      <div className="d-flex align-center gap-2">
                        <img src={URL_COUNTRY + option.image} alt="" className="w-5 h-4" />
                        <p>{option.title}</p>
                      </div>
                    )
                  }))}
                className="custome-select-98A2B3 "

              // value={aOrigin}
              />
            </Form.Item>
          </div>
        </div>


      </Modal >
    </Form>
  )
}
export default ModalCreateCar
